export default function About() {
  return (
    <section id="about" className="py-12 md:py-16 bg-background-100">
      <div className="section-container">
        <h2 className="font-display text-2xl md:text-3xl text-foreground-950 text-center mb-2">关于91影视</h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">了解91影视看片app的品牌故事与平台理念</p>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 rounded-lg p-6 md:p-8">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              91影视看片app成立于2020年，是一家专注于高清影视在线观看的数字娱乐平台。我们致力于为全球华语用户提供高清电影在线观看、蓝光影视资源、高清电视剧免费全集和超清综艺播放等一站式观影服务。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              平台聚合超过<strong>10万部</strong>高清影视资源，覆盖动作、科幻、悬疑、爱情、喜剧、纪录片、动漫等全品类内容。所有片源均经过专业团队筛选与画质优化，确保每一帧画面都达到高清影视大全的顶级标准。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              依托自主研发的智能播放引擎，91影视实现了真正的不缓冲高清播放体验。无论是在线高清播放还是离线缓存观看，用户都能享受到流畅丝滑的观影过程。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              我们的愿景是让每一位影视爱好者都能以最简单的方式，享受最高品质的免费高清看片体验。影视高清片源，尽在91影视。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}